<template>
    <div style="border-bottom: 4px solid #FAFAFA;padding: 0 20px 10px;margin-bottom: 4px">
        <div v-if="['all_order', 'in_transit', 'Refund&Return'].includes(orderStatus)" class="statusFilter">
            <div class="f" style="margin-bottom:20px;" v-if="['all_order'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">{{ $t('Order.List.Components.ListTopFilter.PaymentStatus') }}:</div>
                <template>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('waiting_payment')}" @click="statusFilterClick('waiting_payment', 'payment')">{{ $t('Order.List.Components.ListTopFilter.WaitingPayment') }}</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('partial_refund')}" @click="statusFilterClick('partial_refund', 'payment')">{{ $t('Order.List.Components.ListTopFilter.PartialRefund') }}</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunding')}" @click="statusFilterClick('refunding', 'payment')">{{ $t('Order.List.Components.ListTopFilter.Refunding') }}</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunded')}" @click="statusFilterClick('refunded', 'payment')">{{ $t('Order.List.Components.ListTopFilter.Refunded') }}</div>
                </template>
            </div>
            <div class="f" style="margin-bottom:20px;" v-if="['Refund&Return'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">{{ $t('Order.List.Components.ListTopFilter.PaymentStatus') }}:</div>
                <template>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('refunded')}" @click="statusFilterClick('refunded', 'payment')">{{ $t('Order.List.Components.ListTopFilter.Refunded') }}</div>
                  <div class="statusItem pointer" :class="{active: paymentStatusSelected.includes('partial_refund')}" @click="statusFilterClick('partial_refund', 'payment')">{{ $t('Order.List.Components.ListTopFilter.PartialRefund') }}</div>
                </template>
            </div>
            <div class="f" style="margin-bottom:10px;" v-if="['all_order', 'in_transit'].includes(orderStatus)">
                <div style="color:#10141D;line-height:22px;margin-right:20px">{{ $t('Order.List.Components.ListTopFilter.ShipmentStatus') }}:</div>
                <template v-if="orderStatus === 'all_order'">
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('waiting_to_ship')}" @click="statusFilterClick('waiting_to_ship', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.WaitingToShip') }}</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('partial_shipped')}" @click="statusFilterClick('partial_shipped', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.PartialShipped') }}</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('fully_shipped')}" @click="statusFilterClick('fully_shipped', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.FullyShipped') }}</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('complete')}" @click="statusFilterClick('complete', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.Complete') }}</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('cancel')}" @click="statusFilterClick('cancel', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.Cancel') }}</div>
                </template>
                <template v-else-if="orderStatus === 'in_transit'">
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('fully_shipped')}" @click="statusFilterClick('fully_shipped', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.FullyShipped') }}</div>
                  <div class="statusItem pointer" :class="{active: shipmentStatusSelected.includes('partial_shipped')}" @click="statusFilterClick('partial_shipped', 'shipment')">{{ $t('Order.List.Components.ListTopFilter.PartialShipped') }}</div>
                </template>
            </div>
        </div>
        <div class="f--c statusFilter">
            <el-select :placeholder="$t('orderList.SelectByPlatform')" v-model="searchParams.platformCode" class="selectSelf" @change="cascaderChange" clearable>
                <el-option v-for="item in platformOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
            <el-select v-model="searchParams.storeIds" class="selectSelf" multiple :collapse-tags="true" style="width: 170px" clearable @change="resetPage" filterable>
                <el-option v-for="item in storeSelectList" :key="item.storeId" :value="item.storeId" :label="item.storeName"></el-option>
            </el-select>
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              range-separator="-"
              :start-placeholder="$t('orderList.startDate')"
              :end-placeholder="$t('orderList.endDate')"
              style="border-radius: 30px; width: 234px; margin-right: 8px"
              :default-time="['00:00:00', '23:59:59']"
              placement="bottom-start"
              @change="dateChange"> </el-date-picker>
            <el-input :placeholder="$t('orderList.inputPlaceholder')" v-model="searchParams.searchContent" style="width: 360px; margin-right: 8px" class="inputGroup inputPlaceholder">
                <template slot="append">
                    <div>
                        <el-button icon="el-icon-search" type="success" @click="resetPage"></el-button>
                    </div>
                </template>
            </el-input>
            <div style="background-color: rgba(205, 212, 221, 0.22); height: 28px; width: 28px" class="f-c-c pointer" @click="allExport(1)">
                <i class="el-icon-download" style="font-size: 20px"></i>
            </div>
        </div>
        <el-dialog :title="$t('Order.List.Components.ListTopFilter.ExportOrder')" :visible.sync="exportFailVisible" width="500px">
            <div style="text-align: center">
                <div>
                  <i class="el-icon-error" style="font-size: 50px; color: #a6100c"></i>
                </div>
                <div style="font-weight: bold; font-size: 18px; line-height: 44px">{{ $t('Order.List.Components.ListTopFilter.ExportFailed') }}</div>
                <div style="font-weight: bold; font-size: 16px; line-height: 30px">{{ exportFailReason }}</div>
            </div>
            <span slot="footer" class="f-c-c">
                <el-button type="primary" @click="exportAgain">{{ $t('Order.List.Components.ListTopFilter.ExportAgain') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api'
import dayjs from 'dayjs'
export default {
  props: {
    orderStatus: {
      type: String,
      default: 'AllOrder'
    }
  },
  data() {
    return {
      searchParams: {
        storeIds: [],
        platformCode: undefined,
        searchContent: undefined
      },
      // storeIds: [],
      dateValue: [],
      storeSelectList: [],
      exportFailVisible: false,
      exportFailReason: '',
      exportType: null, // 1 所有导出   2批量勾选导出
      paymentStatusSelected: [],
      shipmentStatusSelected: []
    }
  },
  computed: {
    platformOptions() {
      let arr = this.$store.state.common.platformOptions.map((e) => ({
        value: e.platformCode,
        label: e.platformName,
        level: 1,
        userId: this.$store.state.common.userId
      }))
      if (!arr.length) {
        this.$store.dispatch('common/getPlatformOptions')
      }
      return arr
    }
  },
  methods: {
    // 平台店铺下拉
    cascaderChange(value) {
      if (value) {
        API.orderGetAllStore({ platformCode: value, userId: this.$store.state.common.userId, storeStatus: 1, authorizeStatus: 1 }).then((res) => {
          this.storeSelectList = res.data
        })
      }
      this.storeId = []
      this.resetPage()
    },
    allExport(type) {
      const params = {
        fileType: 2,
        taskType: 14
      }
      if (type === 1) {
        const condition = this.getParams()
        params.condition = JSON.stringify(condition)
      } else {
        if (!this.selectionForPayNow.length) return
        params.condition = JSON.stringify({ arrayIds: this.selectionForPayNow.map((e) => e.id) })
      }
      this.loadingContainer = this.$loading.service({
        text: 'Orders Exporting , Please wait'
      })
      const that = this
      this.exportType = type
      API.importExportFile(params).then((res) => {
        let id = res.data
        let fileStatus = 1
        let requestContainer = setInterval(() => {
          API.fileTaskById({ id }).then((result) => {
            fileStatus = result.data.fileStatus
            if (fileStatus === 3) {
              this.loadingContainer.close()
              if (result.data.fileResult === 1) {
                let url = result.data.fileResultPath
                const ele = document.createElement('a')
                ele.setAttribute('href', url)
                ele.setAttribute('id', 'exportEle')
                document.body.appendChild(ele)
                ele.click()
                document.body.removeChild(ele)
              } else {
                that.exportFailVisible = true
                that.exportFailReason = result.data.causesFailure
              }
              clearInterval(requestContainer)
              return
            } else if ([4, 5, 6].includes(fileStatus)) {
              this.loadingContainer.close()
              clearInterval(requestContainer)
              that.exportFailVisible = true
              that.exportFailReason = result.data.causesFailure
            } else {
              console.log('处理中')
            }
          })
        }, 5000)
      })
    },
    exportAgain() {
      this.exportFailVisible = false
      this.allExport(this.exportType)
    },
    resetPage() {
      this.searchParams.pageNumber = 1
      this.selectionForPayNow = []
      this.$emit('getList', this.getParams())
    },
    dateChange(value) {
      if (value) {
        let from = value[0].valueOf()
        let to = value[1].valueOf()
        this.searchParams.purchaseDateAt = from
        this.searchParams.purchaseDateTo = to
      } else {
        this.searchParams.purchaseDateAt = undefined
        this.searchParams.purchaseDateTo = undefined
      }
      this.resetPage()
    },
    getParams() {
      const params = Object.assign({}, this.searchParams, this.statusHandle())
      return params
    },
    statusHandle() {
      const financialStatus = []
      const refundStatus = []
      const fulfillmentStatus = []
      const status = []
      if (this.paymentStatusSelected.length) {
        switch (this.paymentStatusSelected[0]) {
          case 'waiting_payment':
            status.push('waiting_payment')
            break
          case 'partial_refund':
            refundStatus.push('partial_refund')
            break
          case 'refunding':
            refundStatus.push('refunding')
            break
          case 'refunded':
            refundStatus.push('refunded')
            break
          default:
            break
        }
      }
      if (this.shipmentStatusSelected.length) {
        switch (this.shipmentStatusSelected[0]) {
          case 'waiting_to_ship':
            fulfillmentStatus.push('waiting_to_ship')
            status.push('processing')
            break
          case 'partial_shipped':
            fulfillmentStatus.push('partial_shipped')
            break
          case 'fully_shipped':
            fulfillmentStatus.push('fully_shipped')
            break
          case 'complete':
            status.push('completed')
            break
          case 'cancel':
            status.push('cancel')
            break
          case 'in_transit':
            fulfillmentStatus.push('fully_shipped')
            fulfillmentStatus.push('partial_shipped')
            break
          default:
            break
        }
      }
      switch (this.orderStatus) {
        case 'all_order':

          break
        case 'waiting_payment':
          status.push('waiting_payment')
          break
        case 'waiting_to_ship':
          fulfillmentStatus.push('waiting_to_ship')
          status.push('processing')
          break
        case 'in_transit':
          if (!this.shipmentStatusSelected.length) {
            fulfillmentStatus.push('fully_shipped')
            fulfillmentStatus.push('partial_shipped')
          }
          break
        case 'Refund&Return':
          if (!this.paymentStatusSelected.length) {
            refundStatus.push('refunded')
            refundStatus.push('partial_refund')
          }
          break
        case 'order_info_missing':
          status.push('abnormal_order')
          break
        default:
          break
      }
      return {
        financialStatus: financialStatus,
        refundStatus: refundStatus,
        fulfillmentStatus: fulfillmentStatus,
        status: status
      }
    },
    statusFilterClick(value, way) {
      if (way === 'payment') {
        this.paymentStatusSelected = this.paymentStatusSelected.includes(value) ? [] : [value]
      }
      if (way === 'shipment') {
        this.shipmentStatusSelected = this.shipmentStatusSelected.includes(value) ? [] : [value]
      }
      this.$emit('getList', this.getParams())
    }
  }
}
</script>

<style lang="scss" scoped>
.statusFilter{
    border-bottom: 4px;
    border-color: #8B93A3;
    margin-bottom: 10px;
    .active{
        color: #99C41C;
        background-color: rgba(153, 196, 28, 0.2);
    }
    .statusItem{
        line-height: 22px;
        margin-right: 22px;
        padding: 0 4px;
    }
}
</style>
